module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', [_c('div', {
    staticClass: "center"
  }, [_c('ul', _vm._l((_vm.menu), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('route-item', {
      staticClass: "menu__link",
      attrs: {
        "to": item.route,
        "element": item.element
      },
      nativeOn: {
        "click": function($event) {
          _vm.toogleMenu(item.route)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78beb9fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Menu.vue
// module id = 544
// module chunks = 1